import { useState } from 'react'
import CodeContainer from './CodeContainer.jsx'
import MapContainer from './MapContainer.jsx'
import Univers from './Univers.jsx'
import planetes from './planetes.jsx'


export default function App() {
  // Global reactive data 
  // Univers 
  const [open, setOpen] = useState(true)
  const [questions, setQuestions] = useState(planetes[1]["questions"])
 
  console.log(`questions `)
  console.log(questions)
  // CodeContainer
  const [currentExo, setCurrentExo] = useState(0)
  const [btnColor, setBtnColor] = useState('text-blue-700')
  function currentExoActivate() {
    document.querySelectorAll(".code-container").forEach(elmt => elmt.classList.remove("active"))
    document.querySelectorAll(".code-container")[currentExo].classList.remove("blur")
    document.querySelectorAll(".code-container")[currentExo].classList.add("active")
  }
  // VALIDATION
  function validateCodeTrou() {
   let inputs =  document.querySelectorAll(".code-container")[currentExo].querySelectorAll('.input')
   let res = Array.from(inputs)
                .map(element => element.dataset.status)
                .reduce((acc, valeurActuelle) => acc && valeurActuelle == "true", true)
                console.log(typeof res)
    return res
  }
  
  function validateCarte() {
    console.log(`SelectedCell ${selectedCell}`)
    console.log(`solution ${questions[currentExo].solution}`)
    document.querySelectorAll('.selected-cell').forEach(cell => {
      cell.classList.remove('selected-cell')
    })
  
    return selectedCell == questions[currentExo].solution
  }
  
  function getNextExo(){
    const codeContainerParent = document.querySelector("#code-container-parent")
    const nodeCurrentExo = document.querySelectorAll(".code-container")[currentExo]
    codeContainerParent.scrollTop = codeContainerParent.scrollTop + nodeCurrentExo.offsetHeight + 40
    setCurrentExo(currentExo + 1)
    console.log(questions[currentExo + 1])
    setMapWay(questions[currentExo + 1]["map"] || [])
  }

  function validate() {
    console.log(`Validation de l'exercice ${currentExo}`)
    console.log(`Exercice de type ${questions[currentExo].type}`)

    if (questions[currentExo].type == "carte" && validateCarte()) {
      getNextExo()
    }
    else if (questions[currentExo].type == "code-trou" && validateCodeTrou()) {
      console.log(typeof validateCodeTrou())
      getNextExo()
    }
  }

  // MapCOntainer
  const [selectedCell, setSelectedCell] = useState("")
  const [mapWay, setMapWay] = useState([])
  const [start, setStart] = useState("H8")
  // 
  function selected(cell) {
     setSelectedCell(cell)
  }
  const totalQuestions = questions.length
  // renderer
  return (<>
    {/* Carte univers  */}
    <Univers
      open={open}
      setOpen={setOpen} 
      setQuestions={setQuestions}/>

    {/* Application  */}
    <div className='bg-slate-50	 flex flex-row '>
      <div id="code-container-parent" className="basis-1/3 overflow-y-auto max-h-screen no-scrollbar scroll-smooth pb-96">
        {
          questions.map((q, index) =>
            <CodeContainer
              key={index}
              id={index}
              currentExo={currentExo}
              type={q["type"]}
              btnColor={btnColor}
              currentExoActivate={currentExoActivate}
              validate={validate}
              totalQuestions={totalQuestions}>
              {q["code"]}
            </CodeContainer>
          )}
      </div>
      <MapContainer
        selectedCell={selectedCell}
        selected={selected}
        open={open}
        mapWay={mapWay}
        start={start}
        setOpen={setOpen}
      />
    </div>
  </>

  )


}